
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { convertMonthToString } from "../Utils/ConvertDate";

// /**
//  * =========================
//  * COLLECTION / EARNINGS CARD
//  * =========================
//  */
// export const CollectionVisitCards = (earnings, patient_visits, version) => {
//     const { in_patients, out_patients, total_patients } = patient_visits;

//     const {
//         total_earnings,
//         visits_in_range,
//         visits_out_range,
//         percentage_cash_earnings,
//         percentage_credit_earnings
//     } = earnings;

//     const formatMoneyBlock = (label, value) => (
//         <p className="card-value-text" style={{ fontSize: "18px", margin: 0 }}>
//             {label} {value ? value.toLocaleString() : 0}
//         </p>
//     );

//     return [
//         /**
//          * =========================
//          * TOTAL EARNINGS
//          * =========================
//          */
//         {
//             title: "Total Earnings",
//             tier: ["Premium", "Basic", "Standard"],
//             bodyValues: () => (
//                 <Row>
//                     <Col>
//                         <p className="card-value-text" style={{ fontSize: "20px" }}>
//                             {total_earnings
//                                 ? `Total: ${total_earnings.toLocaleString()}`
//                                 : "0"}
//                         </p>
//                     </Col>
//                 </Row>
//             )
//         },

//         /**
//          * =========================
//          * VISITS IN RANGE
//          * =========================
//          */
//         {
//             title: "Period Visits Revenue",
//             tier: ["Premium", "Basic", "Standard"],
//             bodyValues: () => (
//                 <Row>
//                     <Col>
//                         <OverlayTrigger
//                             placement="top"
//                             overlay={
//                                 <Popover>
//                                     <p style={{ margin: "0.2rem" }}>
//                                         {percentage_cash_earnings || 0}% Cash of Total
//                                     </p>
//                                 </Popover>
//                             }
//                         >
//                             <div>
//                                 {formatMoneyBlock("💵 Cash:", visits_in_range?.cash)}
//                             </div>
//                         </OverlayTrigger>

//                         {formatMoneyBlock("💳 Credit:", visits_in_range?.credit)}

//                         <hr />
//                         {formatMoneyBlock("📊 Total:", visits_in_range?.total)}
//                     </Col>
//                 </Row>
//             )
//         },

//         /**
//          * =========================
//          * VISITS OUT RANGE
//          * =========================
//          */
//         {
//             title: "Previous Visits Revenue",
//             tier: ["Premium", "Basic", "Standard"],
//             bodyValues: () => (
//                 <Row>
//                     <Col>
//                         <OverlayTrigger
//                             placement="top"
//                             overlay={
//                                 <Popover>
//                                     <p style={{ margin: "0.2rem" }}>
//                                         {percentage_credit_earnings || 0}% Credit of Total
//                                     </p>
//                                 </Popover>
//                             }
//                         >
//                             <div>
//                                 {formatMoneyBlock("💵 Cash:", visits_out_range?.cash)}
//                             </div>
//                         </OverlayTrigger>

//                         {formatMoneyBlock("💳 Credit:", visits_out_range?.credit)}

//                         <hr />
//                         {formatMoneyBlock("📊 Total:", visits_out_range?.total)}
//                     </Col>
//                 </Row>
//             )
//         },

//         /**
//          * =========================
//          * PATIENT VISITS
//          * =========================
//          */
//         {
//             title: "Patient Visits",
//             tier: ["Premium", "Basic", "Standard"],
//             bodyValues: () => (
//                 <Row>
//                     {(version === "Standard" || version === "Premium") && (
//                         <Col>
//                             <p className="card-value-text">
//                                 {in_patients ? in_patients.toLocaleString() : 0}
//                             </p>
//                             <p className="card-small-text">IPD</p>
//                         </Col>
//                     )}

//                     <Col>
//                         <p className="card-value-text">
//                             {out_patients ? out_patients.toLocaleString() : 0}
//                         </p>
//                         <p className="card-small-text">OPD</p>
//                     </Col>

//                     <Col>
//                         <p className="card-value-text">
//                             {total_patients ? total_patients.toLocaleString() : 0}
//                         </p>
//                         <p className="card-small-text">Total</p>
//                     </Col>
//                 </Row>
//             )
//         }
//     ];
// };
/**
 * =========================
 * COLLECTION / EARNINGS CARD
 * =========================
 */
// export const CollectionVisitCards = (earnings, patient_visits, version) => {
//     const { in_patients, out_patients, total_patients } = patient_visits;

//     const {
//         total_earnings,
//         total_earnings_cash,
//         total_earnings_credit,
//         visits_in_range,
//         visits_out_range,
//         total_visits_in_range,
//         total_visits_out_range,
//         percentage_cash_earnings,
//         percentage_credit_earnings,
        
//     } = earnings;

//     const formatMoneyBlock = (label, value) => (
//         <p className="card-value-text" style={{ fontSize: "18px", margin: "4px 0" }}>
//             {label} {value || "0"}
//         </p>
//     );

//     return [
//         /**
//          * =========================
//          * TOTAL EARNINGS (Improved with Cash & Credit)
//          * =========================
//          */
//         {
//             title: "Total Earnings",
//             tier: ["Premium", "Basic", "Standard"],
//             bodyValues: () => (
//                 <Row>
//                     <Col>
//                         {formatMoneyBlock("💵 Grand Total Cash:", total_earnings_cash)}
//                         {formatMoneyBlock("💳 Grand Total Credit:", total_earnings_credit)}
//                         <hr className="my-2" />
//                         <p className="card-value-text fw-bold" style={{ fontSize: "20px", margin: 0 }}>
//                             {total_earnings || "0"}
//                             {formatMoneyBlock("📊 Grand Total:", total_earnings)}

//                         </p>
//                     </Col>
//                 </Row>
//             )
//         },

//         /**
//          * =========================
//          * PERIOD VISITS REVENUE (In Range)
//          * =========================
//          */
//         {
//             title: "Current Visits Revenue",
//             tier: ["Premium", "Basic", "Standard"],
//             bodyValues: () => (
//                 <Row>
//                     <Col>
//                         <OverlayTrigger
//                             placement="top"
//                             overlay={
//                                 <Popover>
//                                     <p style={{ margin: "0.2rem" }}>
//                                         {percentage_cash_earnings || 0}% Cash
//                                     </p>
//                                 </Popover>
//                             }
//                         >
//                             <div>
//                                 {formatMoneyBlock("💵 Cash:", visits_in_range?.cash || total_visits_in_range)}
//                             </div>
//                         </OverlayTrigger>

//                         {formatMoneyBlock("💳 Credit:", visits_in_range?.credit)}

//                         <hr className="my-2" />
//                         {formatMoneyBlock("📊 Total:", visits_in_range?.total)}
//                     </Col>
//                 </Row>
//             )
//         },

//         /**
//          * =========================
//          * PREVIOUS VISITS REVENUE (Out Range)
//          * =========================
//          */
//         {
//             title: "Previous Visits Revenue",
//             tier: ["Premium", "Basic", "Standard"],
//             bodyValues: () => (
//                 <Row>
//                     <Col>
//                         <OverlayTrigger
//                             placement="top"
//                             overlay={
//                                 <Popover>
//                                     <p style={{ margin: "0.2rem" }}>
//                                         {percentage_credit_earnings || 0}% Credit
//                                     </p>
//                                 </Popover>
//                             }
//                         >
//                             <div>
//                                 {formatMoneyBlock("💵 Cash:", visits_out_range?.cash)}
//                             </div>
//                         </OverlayTrigger>

//                         {formatMoneyBlock("💳 Credit:", visits_out_range?.credit)}

//                         <hr className="my-2" />
//                         {formatMoneyBlock("📊 Total:", visits_out_range?.total)}
//                     </Col>
//                 </Row>
//             )
//         },

//         /**
//          * =========================
//          * PATIENT VISITS
//          * =========================
//          */
//         {
//             title: "Patient Visits",
//             tier: ["Premium", "Basic", "Standard"],
//             bodyValues: () => (
//                 <Row>
//                     {(version === "Standard" || version === "Premium") && (
//                         <Col>
//                             <p className="card-value-text">
//                                 {in_patients ? in_patients.toLocaleString() : 0}
//                             </p>
//                             <p className="card-small-text">IPD</p>
//                         </Col>
//                     )}

//                     <Col>
//                         <p className="card-value-text">
//                             {out_patients ? out_patients.toLocaleString() : 0}
//                         </p>
//                         <p className="card-small-text">OPD</p>
//                     </Col>

//                     <Col>
//                         <p className="card-value-text">
//                             {total_patients ? total_patients.toLocaleString() : 0}
//                         </p>
//                         <p className="card-small-text">Total</p>
//                     </Col>
//                 </Row>
//             )
//         }
//     ];
// };



/**
 * =========================
 * COLLECTION / EARNINGS CARD
 * =========================
 */
export const CollectionVisitCards = (earnings = {}, patient_visits = {}, version) => {
  const {
    total_earnings = "0",
    total_earnings_cash = "0",
    total_earnings_credit = "0",
    visits_in_range = {},
    visits_out_range = {},
  } = earnings || {};

  const {
    in_patients = 0,
    out_patients = 0,
    total_patients = 0,
  } = patient_visits || {};

  const MoneyRow = ({ label, value, isTotal = false }) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "6px 0",
      }}
    >
      <span
        style={{
          fontSize: "12px",
          color: "#666",
          marginBottom: "2px",
        }}
      >
        {label}
      </span>
      <span
        style={{
          fontSize: isTotal ? "15px" : "13.5px",
          fontWeight: isTotal ? 700 : 600,
          wordBreak: "break-word",
          lineHeight: 1.3,
        }}
      >
        {value ?? "0"}
      </span>
    </div>
  );

  return [
    // Total Earnings
    {
      title: "Total Earnings",
      tier: ["Premium", "Basic", "Standard"],
      bodyValues: () => (
        <div style={{ padding: "4px 0" }}>
          <MoneyRow label="💵 Cash" value={total_earnings_cash} />
          <MoneyRow label="💳 Credit" value={total_earnings_credit} />
          <hr style={{ margin: "8px 0" }} />
          <MoneyRow label="📊 Grand Total" value={total_earnings} isTotal />
        </div>
      ),
    },

    // Current Visits Revenue
    {
      title: "Current Visits Revenue",
      tier: ["Premium", "Basic", "Standard"],
      bodyValues: () => (
        <div style={{ padding: "4px 0" }}>
          <MoneyRow label="💵 Cash" value={visits_in_range?.cash || "0"} />
          <MoneyRow label="💳 Credit" value={visits_in_range?.credit || "0"} />
          <hr style={{ margin: "8px 0" }} />
          <MoneyRow label="📊 Total" value={visits_in_range?.total || "0"} isTotal />
        </div>
      ),
    },

    // Previous Visits Revenue
    {
      title: "Previous Visits Revenue",
      tier: ["Premium", "Basic", "Standard"],
      bodyValues: () => (
        <div style={{ padding: "4px 0" }}>
          <MoneyRow label="💵 Cash" value={visits_out_range?.cash || "0"} />
          <MoneyRow label="💳 Credit" value={visits_out_range?.credit || "0"} />
          <hr style={{ margin: "8px 0" }} />
          <MoneyRow label="📊 Total" value={visits_out_range?.total || "0"} isTotal />
        </div>
      ),
    },

    // Patient Visits (needed for cardList[3])
    {
      title: "Patient Visits",
      tier: ["Premium", "Basic", "Standard"],
      bodyValues: () => (
        <div style={{ padding: "4px 0" }}>
          {(version === "Standard" || version === "Premium") && (
            <MoneyRow label="IPD" value={in_patients?.toLocaleString() || "0"} />
          )}
          <MoneyRow label="OPD" value={out_patients?.toLocaleString() || "0"} />
          <hr style={{ margin: "8px 0" }} />
          <MoneyRow
            label="📊 Total"
            value={total_patients?.toLocaleString() || "0"}
            isTotal
          />
        </div>
      ),
    },
  ];
};


/**
 * =========================
 * INVENTORY
 * =========================
 */
export const Inventory = ({ inventory, title_report_card }) => {
    const {
        out_of_stock,
        expired_items,
        medical_equipment,
        sundries,
        medicine,
        total_products
    } = inventory;

    return (
        <div>
            {title_report_card}
            <div style={{ marginTop: "10px" }}>
                <Row>
                    <Col>
                        <p className="card-value-text">
                            {out_of_stock ? out_of_stock.toLocaleString() : "0"}
                        </p>
                        <p className="card-small-text">Out of Stock</p>
                    </Col>

                    <Col>
                        <p className="card-value-text">
                            {expired_items ? expired_items.toLocaleString() : "0"}
                        </p>
                        <p className="card-small-text">Expired Items</p>
                    </Col>

                    <Col>
                        <p className="card-value-text">
                            {medical_equipment ? medical_equipment.toLocaleString() : "0"}
                        </p>
                        <p className="card-small-text">Medical Equipment</p>
                    </Col>

                    <Col>
                        <p className="card-value-text">
                            {sundries ? sundries.toLocaleString() : "0"}
                        </p>
                        <p className="card-small-text">Sundries</p>
                    </Col>

                    <Col>
                        <p className="card-value-text">
                            {medicine ? medicine.toLocaleString() : "0"}
                        </p>
                        <p className="card-small-text">Medicine</p>
                    </Col>

                    <Col>
                        <p className="card-value-text">
                            {total_products ? total_products.toLocaleString() : "0"}
                        </p>
                        <p className="card-small-text">Total Inventory</p>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

/**
 * =========================
 * INPATIENT STATISTICS
 * =========================
 */
export const InPatientStatistics = ({ in_patient_statistics }) => {
    const {
        bed_occupancy,
        total_beds,
        avg_length_of_stay,
        total_wards,
        admitted_patients
    } = in_patient_statistics;

    const current_month = convertMonthToString(new Date().getMonth());

    return (
        <div>
            <div>
                <p className="dashboard-card-font-color">
                    InPatient Statistics for {current_month}
                </p>
                <div className="orange-short-border"></div>
            </div>

            <div style={{ marginTop: "10px" }}>
                <Row>
                    <Col>
                        <p className="card-value-text">
                            {total_beds ? total_beds.toLocaleString() : "0"}
                        </p>
                        <p className="card-small-text">Total Beds</p>
                    </Col>

                    <Col>
                        <p className="card-value-text">
                            {bed_occupancy ? `${bed_occupancy.toLocaleString()} %` : "0 %"}
                        </p>
                        <p className="card-small-text">Bed Occupancy</p>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <p className="card-value-text">
                            {avg_length_of_stay
                                ? `${avg_length_of_stay.toLocaleString()} days`
                                : "0 days"}
                        </p>
                        <p className="card-small-text">Average Length of Stay</p>
                    </Col>

                    <Col>
                        <p className="card-value-text">
                            {admitted_patients ? admitted_patients.toLocaleString() : "0"}
                        </p>
                        <p className="card-small-text">Admitted Patients</p>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <p className="card-value-text">
                            {total_wards ? total_wards.toLocaleString() : "0"}
                        </p>
                        <p className="card-small-text">Total Wards</p>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

/**
 * =========================
 * MORTALITY RATE
 * =========================
 */
export const MortalityRate = ({ mortality_rate, filter_type }) => {
    const { inpatient, outpatient, total_deaths } = mortality_rate;

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                    <p className="dashboard-card-font-color">Mortality Rate</p>
                    <div className="orange-short-border"></div>
                </div>
                <div>
                    <p className="dropdown-filter">{filter_type}</p>
                </div>
            </div>

            <div style={{ marginTop: "10px" }}>
                <Row>
                    <Col>
                        <p className="card-value-text">
                            {inpatient ? inpatient.toLocaleString() : "0"}
                        </p>
                        <p className="card-small-text">In</p>
                    </Col>

                    <Col>
                        <p className="card-value-text">
                            {outpatient ? outpatient.toLocaleString() : "0"}
                        </p>
                        <p className="card-small-text">Out</p>
                    </Col>

                    <Col>
                        <p className="card-value-text">
                            {total_deaths ? total_deaths.toLocaleString() : "0"}
                        </p>
                        <p className="card-small-text">Total</p>
                    </Col>
                </Row>
            </div>

            <div style={{ display: "flex", justifyContent: "center", marginTop: "15px" }}>
                <Link to={{ pathname: "/reports/deathreports" }}>
                    <button className="sms-dashboard-btn">Death Reports</button>
                </Link>
            </div>
        </div>
    );
};